/**
 * Human-readable labels for internal tool names (footer badges, Working strip fallbacks).
 * Extend {@link TOOL_DISPLAY_LABELS} when new tools ship.
 */
export const TOOL_DISPLAY_LABELS: Record<string, string> = {
  ls: 'List Directory',
  glob: 'Find files',
  read_file: 'Read file',
  use_skill: 'Used skill',
  grep: 'Search in files',
  write_file: 'Write file',
  edit: 'Edit file',
  edit_file: 'Edit file',
  move_file: 'Move file',
  copy_file: 'Copy file',
  make_folder: 'Create folder',
  delete: 'Delete',
  confirm_file_changes: 'Confirm file changes',
  cat: 'Read file',
  execute: 'Run code',
  bio_exec: 'Run code',
  python_exec: 'Python',
  search_internet: 'Web search',
  fetch_web_page: 'Read web page',
  query_omicsbox_kb: 'Knowledge base',
  list_user_files: 'List user files',
  read_user_file: 'Read user file',
  write_user_file: 'Write user file',
  list_dir: 'List Directory',
  list_cwl_workflows: 'List workflows',
  get_cwl_workflow_params: 'Workflow parameters',
  run_cwl_workflow: 'Run workflow',
  start_transfer: 'Transfer data',
  get_transfer_status: 'Transfer status',
}

export function formatToolDisplayLabel(toolName: string): string {
  const key = toolName.trim()
  if (!key) return toolName
  const lookup = key.toLowerCase()
  return TOOL_DISPLAY_LABELS[lookup] ?? key.replace(/_/g, ' ')
}
